export default function ({ redirect, $auth }) {
  if (!$auth.user.is_system_admin) {
    return redirect({
      path: "/arm",
    })
  }
}
